/* Full Feast — click-to-zoom for article images.
   Any hero or in-body image opens full size in an overlay. Keyboard
   accessible (Enter/Space to open, Escape to close) and no dependencies. */
(function () {
  var SELECTOR = '.ff-article__hero-image img, .ff-article__main .rte img';

  function fullSrc(img) {
    // Shopify CDN: request a large render rather than the thumbnail size.
    var src = img.currentSrc || img.src || '';
    return src.replace(/([?&])width=\d+/, '$1width=2000');
  }

  var overlay, overlayImg;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'ff-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', (window.FF_I18N || {}).image_viewer || 'Image viewer');
    overlay.innerHTML =
      '<button class="ff-zoom-close" type="button" aria-label="' + ((window.FF_I18N || {}).close_image || 'Close image') + '">&times;</button>' +
      '<img class="ff-zoom-image" alt="">';
    document.body.appendChild(overlay);
    overlayImg = overlay.querySelector('.ff-zoom-image');
    overlay.addEventListener('click', function (e) {
      if (e.target !== overlayImg) close();
    });
    overlay.querySelector('.ff-zoom-close').addEventListener('click', close);
  }

  var lastFocus = null;

  function open(img) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    overlayImg.src = fullSrc(img);
    overlayImg.alt = img.alt || '';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.ff-zoom-close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function wire() {
    document.querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.dataset.zoomWired) return;
      /* An image inside a link or button belongs to that control. The
         inline sauce chip is a link to the product — clicking it must go
         to the product page, not open a lightbox over it. */
      if (img.closest('a, button')) {
        img.dataset.zoomWired = 'skip';
        return;
      }
      img.dataset.zoomWired = '1';
      img.classList.add('ff-zoomable');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.alt || (window.FF_I18N || {}).image || 'Image') + ' ' + ((window.FF_I18N || {}).click_to_enlarge || '(click to enlarge)'));
      img.addEventListener('click', function () { open(img); });
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(img); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  // Late-loading blocks (app embeds, lazy content) get wired too.
  new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true });
})();
